﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
const LoanCalcView_1 = require("../com/contractViews/LoanCalcView");
class StateDashboard extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDashboard, "Smart Vaults DApp", true, false);
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = 'images/favicon_open.svg';
            this.gui.showPage(this.page);
            // const blockPrices = new com.CmpBlockPriceKeepers();
            // this.page.ctrls.blocks.append(blockPrices);
            // const priceKeeperPLS = new PriceKeeperView(this.app.chain.priceKeeperPLS, "USD");
            // await priceKeeperPLS.refresh();
            // blockPrices.ctrls.blockPrices.append(priceKeeperPLS);
            const calc = new LoanCalcView_1.LoanCalcView();
            yield calc.refreshAsync();
            this.page.ctrls.blocks.append(calc);
            // const priceKeeperUp = new PriceKeeperView(this.app.chain.priceKeeperUP, "USDL");
            // priceKeeperUp.refresh();
            // blockPrices.ctrls.blockPrices.append(priceKeeperUp);
            // const blockUpTotal = new UPTokenView(new ERC20Contract(this.app.chain.addressTokenUP, this.app.chain.web3), this.app.chain.burnableUp);
            // blockUpTotal.refresh();
            // this.page.ctrls.blocks.append(blockUpTotal);
            // const blockUpManager = new UpManagerView(this.app.chain.upManager);
            // this.page.ctrls.blocks.append(blockUpManager);
            // const blockExchangers = new com.CmpBlockInternalExchangers();
            // let internalExchangerBnB = new InternalExchangerBnBView(this.app.chain.internalExchangerBnB);
            // blockExchangers.ctrls.blockExchangers.append(internalExchangerBnB); internalExchangerBnB.refresh();
            // let internalExchangerSP = new InternalExchangerSPView(this.app.chain.internalExchangerSP);
            // blockExchangers.ctrls.blockExchangers.append(internalExchangerSP); internalExchangerSP.refresh();
            // this.page.ctrls.blocks.append(blockExchangers);
            // const blockPools = new com.CmpBlockPools();
            // let bbPool = new BuyBurnPoolView(this.app.chain.buyBurnPool);
            // blockPools.ctrls.blockPools.append(bbPool); bbPool.refresh();
            // let stabPool = new StabilityPoolView(this.app.chain.stabilityPool);
            // blockPools.ctrls.blockPools.append(stabPool); stabPool.refresh();
            // this.page.ctrls.blocks.append(blockPools);
            // const blockChart = new com.CmpBlockChart();
            // this.page.ctrls.blocks.append(blockChart);
            // globalThis.showChart('1hour');
            // const blockContactsVaults = new com.CmpBlockContracts();
            // this.page.ctrls.blocks.append(blockContactsVaults);
            // for(const vc of this.app.chain.liquidControllers)
            // {
            //     let vault = new LiquidControllerView(vc);
            //     blockContactsVaults.ctrls.blockContainer.append(vault); vault.refresh();
            // }
            //const blockContactsShareX = new com.CmpBlockContracts();
            // this.page.ctrls.blocks.append(blockContactsShareX);
            // let shareX = new ShareXView(this.app.chain.shareX);
            // shareX.refresh();
            // blockContactsShareX.ctrls.blockContainer.append(shareX);
            // this.page.ctrls.list.append(shareX); shareX.refresh();
            // this.page.ctrls.list.append(new com.CmpNextLine());
            // let upToken = new UPTokenView(new ERC20Contract(this.app.chain.addressTokenUP, this.app.chain.web3), new BurnableContract(this.app.chain.addressTokenUP, this.app.chain.web3));
            // this.page.ctrls.list.append(upToken); await upToken.refresh();
            // if (upToken.ctrls.lTotalSupply.text=='0.')
            // {
            //     let airDrop = new AirDropView();
            //     this.page.ctrls.list.append(airDrop);
            // }
            // this.page.ctrls.list.append(new com.CmpNextLine());
            // let upManager = new UpManagerView(this.app.chain.upManager);
            // this.page.ctrls.list.append(upManager); upManager.refresh();   
            // this.page.ctrls.list.append(new com.CmpNextLine());
            // let priceKeeper = new PriceKeeperView(this.app.chain.priceKeeperPLS, "USD");
            // this.page.ctrls.list.append(priceKeeper); priceKeeper.refresh();
            // priceKeeper = new PriceKeeperView(this.app.chain.priceKeeperUP, "USDL");
            // this.page.ctrls.list.append(priceKeeper); priceKeeper.refresh();        
            // this.page.ctrls.list.append(new com.CmpNextLine()); 
            // for(const vc of this.app.chain.liquidControllers)
            // {
            //     let vault = new LiquidControllerView(vc);
            //     this.page.ctrls.list.append(vault); vault.refresh();
            // }
            // this.page.ctrls.list.append(new com.CmpNextLine());
            // let shareX = new ShareXView(this.app.chain.shareX);
            // this.page.ctrls.list.append(shareX); shareX.refresh();
            // this.page.ctrls.list.append(new com.CmpNextLine());
            // document.querySelector('#lLoading').innerHTML='';
            //globalThis.showChart();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            // this._map = L.map('map').setView([48.142723, 11.576843], 10);
            // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     maxZoom: 19,
            //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            // }).addTo(this._map);
            // await this._refresh();
        });
    }
    _refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            // let vehicles = await this.lockgui(this.app.api.admin.activeManager.getActiveVehicles(0,1000));
            // if (!vehicles) return;
            // let icon = L.icon({
            //     iconUrl: 'images/icons/map-pin_driver.svg',
            //     iconSize: [30, 60],
            //     iconAnchor: [15, 45]            
            // });     
            // for(const m of this._markers) m.removeFrom(this._map);
            // this._markers=[];
            // for(const d of vehicles) 
            //     this._markers.push( L.marker(d.coordinates, {icon: icon}).addTo(this._map));
        });
    }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map